import { Pipe, PipeTransform } from '@angular/core';
import { MinimumSlideInformation, SlideType } from "@pcp/core/interfaces";

@Pipe({
    name: 'isVideoSlide',
    pure: true
})
export class IsVideoSlidePipe implements PipeTransform {
    transform(slide: MinimumSlideInformation, ...args: unknown[]): unknown {
        return slide.type === SlideType.video;
    }
}
